/*
Тип агрегации для диаграммы водопада спектров
*/
export enum WaterfallDiagramAggregateType {
  Average = 'avg',
  Maximum = 'max',
}

/*
Статус выполнения задачи получения данных для диаграммы водопада спектра
*/
export enum WaterfallTaskStatus {
  NotRunning = 'not running',
  Running = 'running',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Deleted = 'deleted',
}

/*
Действия для пунктов легенды в диаграмме сигналов для главного датчика
*/
export enum VibrationDiagnosticAction {
  Detach = 'detach',
  Delete = 'delete',
  ChangeVisibility = 'changeVisibility',
}
